module.exports = __webpack_public_path__ + "img/quick-es.df181a6e.png";